import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import * as commonActions from "../../../../actions/common.actions";
import * as projectActions from "../../../../actions/project.actions";

import ProjectHired from "../components/ProjectHired";

const rejectedHeader = () => ({
  color: "grey",
  title: "This Project has Been Rejected by The Second Shift",
  text: (
    <span>
      If you believe this was done in error, please{" "}
      <b>
        <a href="https://thesecondshift.com/contact-us" target="_blank">
          contact us
        </a>
      </b>
      .
    </span>
  )
});

class ProjectHiredContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      status: null
    };

    this.completeProject = this.completeProject.bind(this);
  }

  componentDidMount() {
    this.props.projectActions.getProject(this.props.match.params.projectId);
    this.props.projectActions.getPitchesByProjectId(
      this.props.match.params.projectId
    );
  }

  componentWillUnmount() {
    this.props.commonActions.setSubHeader({});
    this.props.commonActions.setHeaderBar({});
  }

  completeProject(memberId) {
    this.props.projectActions.completeProjectByEmployer(
      this.props.match.params.projectId,
      memberId
    );
  }

  countHired = pitches => {
    var totalHired = 0;

    pitches.forEach(pitch => {
      if (pitch.accepted) {
        totalHired++;
      }
    });

    return totalHired;
  };

  countSelected = pitches => {
    var total = 0;

    pitches.forEach(pitch => {
      if (pitch.accepted === null) {
        total++;
      }
    });

    return total;
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.pitches !== nextProps.pitches) {
      const projectId = this.props.match.params.projectId;
      const pitches = nextProps.pitches;

      const subHeader = {
        items: [
          {
            caption: `Project Detail`,
            url: `/company/project/${projectId}`
          },
          {
            caption: `Candidates (${this.countSelected(pitches)})`,
            url: `/company/project/${projectId}/candidates`
          },
          {
            caption: `Selected (${this.countHired(pitches)})`,
            url: `/company/project/${projectId}/hired`
          }
        ],
        activeItem: 2,
        track: true
      };

      this.props.commonActions.setSubHeader(subHeader);
    }
  }

  componentDidUpdate(prevState) {
    this.setHeaderBar(prevState);
  }

  setHeaderBar(prevState) {
    const project = this.props.project;
    const status = _.get(project, "status.name");

    let headerBar = {};

    if (status) {
      switch (status) {
        case "rejected":
          headerBar = rejectedHeader();
          break;
      }
    }

    if (prevState.status && status !== prevState.status) {
      this.props.commonActions.setHeaderBar(headerBar);
      this.setState({ status });
    }
  }

  render() {
    const { pitches } = this.props;
    const hired = pitches.filter(pitch => pitch.accepted);

    return (
      <ProjectHired
        id={this.props.match.params.projectId}
        completeProject={this.completeProject}
        hired={hired}
      />
    );
  }
}

const mapStateToProps = state => ({
  project: state.project,
  pitches: state.project.pitches
});

const mapDispatchToProps = dispatch => {
  return {
    commonActions: bindActionCreators(commonActions, dispatch),
    projectActions: bindActionCreators(projectActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProjectHiredContainer);



// WEBPACK FOOTER //
// ./src/routes/employer/projectInformation/containers/ProjectHiredContainer.js